// Mock data for Mark's Barber Shop

export const services = [
  {
    id: 1,
    name: "Classic Haircut",
    description: "Timeless precision cutting tailored to your style and face shape",
    price: "RM 45",
    duration: "45 min"
  },
  {
    id: 2,
    name: "Skin Fade",
    description: "Modern fade technique with seamless blending and sharp lines",
    price: "RM 55",
    duration: "60 min"
  },
  {
    id: 3,
    name: "Beard Trim",
    description: "Expert beard shaping and grooming for the perfect finish",
    price: "RM 25",
    duration: "20 min"
  },
  {
    id: 4,
    name: "Beard Styling",
    description: "Complete beard transformation with premium products",
    price: "RM 35",
    duration: "30 min"
  },
  {
    id: 5,
    name: "Hot Towel Shave",
    description: "Traditional straight razor shave with hot towel treatment",
    price: "RM 65",
    duration: "45 min"
  },
  {
    id: 6,
    name: "Hair Wash",
    description: "Relaxing scalp massage with premium shampoo",
    price: "RM 15",
    duration: "15 min"
  },
  {
    id: 7,
    name: "Scalp Treatment",
    description: "Therapeutic scalp care for healthier hair growth",
    price: "RM 45",
    duration: "30 min"
  },
  {
    id: 8,
    name: "Hair Colour",
    description: "Professional hair coloring with premium products",
    price: "From RM 120",
    duration: "90 min"
  },
  {
    id: 9,
    name: "Kids Haircut",
    description: "Patient and professional haircuts for young gentlemen",
    price: "RM 30",
    duration: "30 min"
  },
  {
    id: 10,
    name: "Senior Haircut",
    description: "Comfortable grooming service for senior customers",
    price: "RM 35",
    duration: "40 min"
  }
];

export const branches = [
  {
    id: 1,
    name: "Puchong",
    state: "Selangor",
    address: "32-G, Jalan PU 7/3, Taman Puchong Utama, 47000 Puchong, Selangor",
    phone: "+60 3-8070 0000",
    whatsapp: "60380700000",
    hours: "10:00 AM - 10:00 PM (Daily)",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.5!2d101.6!3d3.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM8KwMDAnMDAuMCJOIDEwMcKwMzYnMDAuMCJF!5e0!3m2!1sen!2smy!4v1234567890",
    rating: 4.9,
    reviews: 245
  },
  {
    id: 2,
    name: "Bayan Baru",
    state: "Penang",
    address: "Block A-1-3, Bayan Point, Jalan Mahsuri, 11950 Bayan Baru, Penang",
    phone: "+60 4-6410 0000",
    whatsapp: "60464100000",
    hours: "10:00 AM - 10:00 PM (Daily)",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3972.0!2d100.3!3d5.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwMTgnMDAuMCJOIDEwMMKwMTgnMDAuMCJF!5e0!3m2!1sen!2smy!4v1234567890",
    rating: 5.0,
    reviews: 189
  },
  {
    id: 3,
    name: "Sungai Nibong",
    state: "Penang",
    address: "12-G-3, Jalan Sungai Nibong, 11900 Bayan Lepas, Penang",
    phone: "+60 4-6420 0000",
    whatsapp: "60464200000",
    hours: "10:00 AM - 10:00 PM (Daily)",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3972.1!2d100.3!3d5.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwMTgnMDAuMCJOIDEwMMKwMTgnMDAuMCJF!5e0!3m2!1sen!2smy!4v1234567890",
    rating: 4.9,
    reviews: 167
  },
  {
    id: 4,
    name: "Bukit Mertajam",
    state: "Penang",
    address: "23-G, Jalan Perda Selatan, Bandar Perda, 14000 Bukit Mertajam, Penang",
    phone: "+60 4-5380 0000",
    whatsapp: "60445380000",
    hours: "10:00 AM - 10:00 PM (Daily)",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3972.5!2d100.4!3d5.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwMTgnMDAuMCJOIDEwMMKwMjQnMDAuMCJF!5e0!3m2!1sen!2smy!4v1234567890",
    rating: 5.0,
    reviews: 203
  },
  {
    id: 5,
    name: "Perak Road",
    state: "Penang",
    address: "156-G, Jalan Perak, Georgetown, 10150 Penang",
    phone: "+60 4-2280 0000",
    whatsapp: "60442280000",
    hours: "10:00 AM - 10:00 PM (Daily)",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.8!2d100.3!3d5.4!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwMjQnMDAuMCJOIDEwMMKwMTgnMDAuMCJF!5e0!3m2!1sen!2smy!4v1234567890",
    rating: 4.9,
    reviews: 221
  }
];

export const reviews = [
  {
    id: 1,
    name: "Ahmad Zakaria",
    rating: 5.0,
    date: "2 weeks ago",
    comment: "Exceptional service! The barbers are true professionals. Best skin fade I've ever had. The attention to detail is outstanding.",
    branch: "Puchong"
  },
  {
    id: 2,
    name: "Michael Tan",
    rating: 5.0,
    date: "1 month ago",
    comment: "Premium experience from start to finish. The hot towel shave is absolutely worth it. Clean environment and friendly staff.",
    branch: "Bayan Baru"
  },
  {
    id: 3,
    name: "Raj Kumar",
    rating: 4.9,
    date: "3 weeks ago",
    comment: "Been coming here for 6 months now. Consistent quality every single time. The beard styling service is top-notch.",
    branch: "Perak Road"
  },
  {
    id: 4,
    name: "David Lim",
    rating: 5.0,
    date: "1 week ago",
    comment: "Best barber shop in Penang! Professional barbers who really understand men's grooming. Highly recommend.",
    branch: "Sungai Nibong"
  },
  {
    id: 5,
    name: "Azman Ibrahim",
    rating: 5.0,
    date: "2 months ago",
    comment: "Love the modern yet classic vibe. The barbers take their time to get every detail perfect. Worth every ringgit.",
    branch: "Bukit Mertajam"
  },
  {
    id: 6,
    name: "Jonathan Wong",
    rating: 4.9,
    date: "3 days ago",
    comment: "Fantastic experience! The consultation before the haircut shows they really care about what you want. Will definitely return.",
    branch: "Puchong"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Experienced Professional Barbers",
    description: "Our master barbers bring years of expertise in classic and modern techniques"
  },
  {
    id: 2,
    title: "Premium Grooming Products",
    description: "We use only the finest international grooming brands for exceptional results"
  },
  {
    id: 3,
    title: "Clean & Hygienic Environment",
    description: "Strict sanitization protocols ensure a safe and pristine grooming experience"
  },
  {
    id: 4,
    title: "Luxury Barber Experience",
    description: "Enjoy complimentary beverages and a sophisticated atmosphere"
  },
  {
    id: 5,
    title: "Walk-in & Appointment",
    description: "Flexible booking options to suit your schedule and convenience"
  },
  {
    id: 6,
    title: "Multiple Locations",
    description: "5 premium locations across Selangor and Penang for your convenience"
  },
  {
    id: 7,
    title: "Comfortable Waiting Area",
    description: "Relax in our lounge with refreshments while you wait"
  },
  {
    id: 8,
    title: "Consistent Quality",
    description: "Every visit guarantees the same exceptional standard of service"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Do I need an appointment?",
    answer: "We welcome both walk-ins and appointments. However, we recommend booking ahead during peak hours (evenings and weekends) to avoid waiting time."
  },
  {
    id: 2,
    question: "Can I walk in without booking?",
    answer: "Yes, absolutely! We accept walk-in customers at all our branches. However, appointment customers get priority service."
  },
  {
    id: 3,
    question: "How long does a haircut take?",
    answer: "A classic haircut typically takes 45 minutes, while more detailed services like skin fades may take up to 60 minutes. We never rush to ensure perfection."
  },
  {
    id: 4,
    question: "Do you offer beard services?",
    answer: "Yes! We offer comprehensive beard services including beard trims, styling, and grooming. We also provide traditional hot towel shaves with straight razors."
  },
  {
    id: 5,
    question: "Do you cut children's hair?",
    answer: "Yes, we offer kids haircuts for children of all ages. Our barbers are patient and experienced with young customers."
  },
  {
    id: 6,
    question: "What payment methods are accepted?",
    answer: "We accept cash, credit/debit cards, and major e-wallets including Touch 'n Go, GrabPay, and Boost."
  },
  {
    id: 7,
    question: "How do I book an appointment?",
    answer: "You can book via WhatsApp by clicking the 'Book Appointment' button on our website, or call any of our branches directly."
  },
  {
    id: 8,
    question: "Are your products halal?",
    answer: "Yes, we use premium grooming products that are suitable for all customers and maintain high quality standards."
  }
];